import {
  DateTimeField,
  NumberField,
  RelationshipFieldMany,
  StringField,
  LongTextField,
} from "../plugins/Cruxtify/field-types";
import {
  DateTimeProperty,
  NumberProperty,
  RelationshipPropertyMany,
  StringProperty,
} from "../plugins/Cruxtify/property-types";
import {
  UserPermission,
  UserPermissions,
  UserRole,
} from "../plugins/Cruxtify/UserPermission";
import { ApcCrudModel } from "./ApcCrudModel";

export class OptionGroup extends ApcCrudModel {
  public static icon = "mdi-puzzle";
  protected static _typeLabel = "Option Group";
  protected static asProperty = "option_group";
  public static api = {
    path: "option-groups",
  };

  protected static routeBase = "option-groups";

  protected static userPermissions = new UserPermissions(
    {
      [UserRole.SuperAdmin]: UserPermission.Edit,
      [UserRole.LoggedIn]: UserPermission.Read,
    },
    UserPermission.New
  );

  protected static propertyDefinitions = [
    {
      type: NumberProperty,
      opts: {
        name: "id",
        label: "ID",
        userPermissions: UserPermission.Hidden,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "created_at",
        label: "Created At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "updated_at",
        label: "Updated At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "name",
        label: "Name",
        sortable: true,
        rules: ["required"],
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "description",
        label: "Description",
      },
    },
    {
      type: RelationshipPropertyMany,
      opts: {
        name: "options",
        label: "Options",
        relatedModel: "Option",
        foreignProperty: "option_groups",
      },
    },
  ];

  protected static fieldDefinitions = [
    { type: NumberField, opts: { property: "id" } },
    { type: DateTimeField, opts: { property: "created_at" } },
    { type: DateTimeField, opts: { property: "updated_at" } },
    { type: StringField, opts: { property: "name", isPrimaryLabelField: 1 } },
    { type: LongTextField, opts: { property: "description" } },
    {
      type: RelationshipFieldMany,
      opts: {
        property: "options",
        collectionLayoutOpts: {
          enableSearch: true,
          enableDynamicFilters: true,
          noRefresh: true,
        },
      },
    },
  ];

  protected static collectionLayoutDefinitions = [
    {
      id: "table",
      columnFields: ["name", "description", "created_at"],
      enableSearch: true,
      enableDynamicFilters: true,
      useModal: true,
      dynamicFilterOptions: {
        filterFields: ["name", "description", "created_at", "updated_at"],
      },
      defaultSort: [
        {
          field: "name",
          order: "asc",
        },
      ],
    },
  ];

  protected static modelLayoutDefinitions = [
    {
      type: "FieldSetGridLayout",
      opts: {
        id: "optionGroupDetails",
        fieldSets: [
          {
            id: "main",
            fields: ["name", "description"],
          },
          {
            id: "options",
            fields: ["options"],
          },
          {
            id: "meta",
            fields: ["created_at", "updated_at", "id"],
          },
        ],
      },
    },
  ];
}
